import { render, staticRenderFns } from "./CatalogBandTitle.vue?vue&type=template&id=9bb3d876"
import script from "./CatalogBandTitle.vue?vue&type=script&lang=js"
export * from "./CatalogBandTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports